import * as React from 'react';

export interface IProps {
  num: number;
  color: string;
}

class NumberedListIcon extends React.PureComponent<IProps> {
  public render(): JSX.Element {
    let { num, color } = this.props;

    return (
      <div className="home-page__list-icon-container">
        <span className={`home-page__list-icon-num ${color}-number-icon`}>{num}</span>
      </div>
    );
  }
}

export { NumberedListIcon };
